<template>
  <div class="activity">
    <div class="poster-content">
      <img class="poster" :src="posterUrl" />
    </div>
    <div class="share-content">
      <div class="title">分享到</div>
      <div class="btn-list">
        <div
          class="btn-item"
          v-for="(item, index) in iconList"
          :key="index"
          @click="bindShareSelect(item)"
        >
          <div class="icon">
            <img class="icon-image" :src="item.icon" alt="" />
          </div>
          <div>{{ item.name }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { eventObj } from '@/components/app/share/share-method.js'
export default {
  components: {},
  data() {
    return {
      posterUrl: '',
      shareOptions: {
        //分享参数
        url: '',
        desc: 'xxxxx',
        title: 'aaaaaaa',
        thumbnail: ''
      },
      iconList: [
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon2',
          name: '微信好友',
          id: 1
        },
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon3',
          name: '朋友圈',
          id: 2
        },
        {
          icon: 'https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-03/3005ee2211ee169ae90075bc1138d1da_wh=169_169.png',
          name: '保存到相册',
          id: 3
        }
      ]
    }
  },
  created() {
    console.log(this.$route)
    let posterUrl = this.$route.query.posterUrl
    if (posterUrl) {
      this.posterUrl = posterUrl
    } else {
      this.$toast('未获取到图片')
    }
  },
  methods: {
    bindShareSelect(options) {
      if (!this.posterUrl) {
        this.$toast('未获取到图片')
        return
      }
      let shareOptions = Object.assign({}, this.shareOptions)
      switch (options.id) {
        // 分享图片到微信好友
        case 1:
          shareOptions.url = this.posterUrl
          eventObj.shareImageUrlToWxFriend(shareOptions)
          break
        // 分享图片到微信朋友圈
        case 2:
          shareOptions.url = this.posterUrl
          eventObj.shareImageUrlToWxCircle(shareOptions)
          break
        case 3:
          eventObj.saveImageUrlToPhone(this.posterUrl)
          break
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.activity {
  user-select: none;
  background: #f1f1f1;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .poster-content {
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
    width: 100%;
    box-sizing: border-box;
    padding: 29px 20px 24px;

    .poster {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  .share-content {
    width: 100%;
    padding-bottom: 40px;

    .title {
      text-align: center;
      font-family: PingFangSC, PingFang SC;
      font-size: 14px;
      color: rgba(48, 48, 56, 0.8);
      line-height: 16px;
      margin-bottom: 17px;
    }

    .btn-list {
      display: flex;
      align-items: center;
      justify-content: space-around;

      .btn-item {
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        font-family: PingFangSC, PingFang SC;
        font-size: 13px;
        color: #303038;
        line-height: 16px;

        .icon {
          width: 50px;
          height: 50px;
          background: #ffffff;
          border-radius: 50%;
          margin-bottom: 7px;
          display: flex;
          align-items: center;
          justify-content: center;

          .icon-image {
            width: 28px;
            height: 28px;
            object-fit: contain;
          }
        }
      }
    }
  }
}
</style>
